<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import {USER_REQUEST} from './_store/user/actiontypes';
import {AUTH_LOGOUT} from './_store/authenticate/actiontypes'
import axios from 'axios'

export default {
  created: function () {
    let language = navigator.language || navigator.userLanguage;
    if (this.$store.getters.isAuthenticated) {
      this.$store.dispatch(USER_REQUEST)
    }
    axios.interceptors.response.use(undefined, function (err) {
      return new Promise(function (resolve, reject) {
        if (err.status === 401) {
          // if you ever get an unauthorized, logout the user
          this.$store.dispatch(AUTH_LOGOUT);
          this.$router.push('/');
        }
        throw err;
      });
    });
  }
}
</script>
<style>
  .card {
    border:none !important;
  }
  .cardcontainer {
    padding-top: 100px;
  }
  .alert-danger{
    padding: 0.5rem !important;
    margin-top: 0.5rem !important;
  }
  .btn-primary {
    background-color : #6CB9D5 !important;
  }
</style>
<style src="@/vendor/styles/bootstrap.scss" lang="scss"></style>
<style src="@/vendor/styles/appwork.scss" lang="scss"></style>
<style src="@/vendor/styles/theme-corporate.scss" lang="scss"></style>
<style src="@/vendor/styles/colors.scss" lang="scss"></style>
<style src="@/vendor/styles/uikit.scss" lang="scss"></style>
<style lang="css" href="@/vendor/fonts/ionicons.css"></style>
<style src="./style.scss" lang="scss"></style>
